export default "__VITE_PUBLIC_ASSET__1f10c699__"